module.exports = __webpack_public_path__ + "img/medicina.dede4414.png";